import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { WretchError } from 'wretch/resolver'

import { useRedirect } from '@/lib/hooks/use-redirect'
import { uploadDocumentsMutation } from '@/lib/queries/business/v1/ocr/mutations'
import { isApiErrorResponse } from '@/lib/types/predicate'

import { useUploadDocumentStore } from '../../stores/use-upload-document-store'

export const useProcessDocumentProgressPage = () => {
  const navigate = useNavigate()

  const { files } = useUploadDocumentStore()

  const { mutateAsync: uploadDocuments } = useMutation(uploadDocumentsMutation)

  useRedirect({ condition: files.length === 0, redirectTo: '/upload-document' })

  useEffect(() => {
    if (!files || files.length === 0) {
      return
    }

    void uploadDocuments(
      { files },
      {
        onSuccess: ({ jobId }) => {
          void navigate({
            to: '/process-document/review/$jobId',
            params: {
              jobId: `${jobId}`,
            },
          })
        },
        onError: (error) => {
          if (error instanceof WretchError && isApiErrorResponse(error.json)) {
            const { code, description } = error.json
            void navigate({
              to: '/process-document/error',
              search: {
                code,
                description,
              },
            })
          } else {
            void navigate({
              to: '/process-document/error',
            })
          }
        },
      }
    )
  }, [files, navigate, uploadDocuments])
}
